export default "__VITE_ASSET__0LK0VXyj__"